import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { authGuard } from '@core/guards/auth.guard'
import { IntegrationLayersDetailedComponent } from '@pages/integration-platform/integration-layer-detailed/integration-layer-detailed.component'
import { IntegrationLayersComponent } from '@pages/integration-platform/integration-layers/integration-layers.component'
import { IntegrationLogsComponent } from '@pages/integration-platform/integration-logs/integration-logs.component'
import { IntegrationHomeComponent } from '@pages/integration-platform/integration-platform.component'
import { MapComponent } from '@pages/map/map.component'
import { PrivacyPolicyComponent } from '@pages/privacy-policy/privacy-policy.component'
import { WelcomePageComponent } from '@pages/welcome-page/welcome-page.component'

export const routes: Routes = [
  // @ToDo: Lazy load the modules
  {
    path: '',
    component: WelcomePageComponent,
  },
  {
    path: 'map',
    component: MapComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'integration',
    canActivateChild: [authGuard],
    children: [
      {
        path: 'manual',
        component: IntegrationHomeComponent,
      },
      {
        path: 'layers',
        component: IntegrationLayersComponent,
      },
      {
        path: 'layers/:layerName/detailed',
        component: IntegrationLayersDetailedComponent,
      },
      {
        path: 'logs',
        component: IntegrationLogsComponent,
      },
      {
        path: '',
        redirectTo: 'manual',
        pathMatch: 'full',
      },
      {
        path: '**',
        redirectTo: 'manual',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/',
  },
]

@NgModule({
  imports: [
    // Routing
    RouterModule.forRoot(routes, {}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
